import { Grid, Typography } from '@mui/material';
import {
    ConfirmationWorkflowConsumer,
    ConfirmationWorkflowContext,
    ConfirmationWorkflowReducer,
    DEFAULT_INITIAL_STATE
} from '@tassat/workflow';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getAssociatedWalletsbyAccount } from 'Selectors/accountRelationships';

import FirmAccountWalletsAgGrid from './firmAccountWalletsGrid';

import type { FirmAccountWalletsProps } from '.';

export function FirmAccountWallets(props: FirmAccountWalletsProps) {
    const {
        classes,
        account
    } = props;
    const wallets = useAppSelector((state) => getAssociatedWalletsbyAccount(state, account.AccountId));

    const [
        confirmationWorkflowState,
        dispatchConfirmationWorkflowAction
    ] = React.useReducer(ConfirmationWorkflowReducer, DEFAULT_INITIAL_STATE);
    const confirmationContext = React.useMemo(() => {
        return {
            confirmationWorkflowState,
            dispatchConfirmationWorkflowAction
        };
    }, [ confirmationWorkflowState, dispatchConfirmationWorkflowAction ]);

    return (
        <ConfirmationWorkflowContext.Provider value={confirmationContext}>
            <Grid
                className={classes.root}
                container
                direction='column'
                spacing={0}
                wrap='nowrap'
            >
                <Grid
                    className={classes.headerContainer}
                    container
                    direction='row'
                    justifyContent='space-between'
                    spacing={0}
                    wrap='nowrap'
                >
                    <Grid
                        container
                        direction='column'
                        item
                        spacing={0}
                        wrap='nowrap'
                        xs={6}
                    >
                        <Typography
                            className={classes.panelHeader}
                            variant='h6'
                        >Associated Accounts
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    item
                    xs={12}
                >
                    <FirmAccountWalletsAgGrid
                        wallets={wallets}
                    />
                </Grid>
                <ConfirmationWorkflowConsumer />
            </Grid>
        </ConfirmationWorkflowContext.Provider>
    );
}